export const appsCatalogSubscriptionsListDatatable = "/apps/catalog_subscriptions_list_datatable";
